import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oauth.remote-assistant.ai';

class BusinessLookupService {
  async getAuthToken() {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString() || session.tokens?.accessToken?.toString();
      if (!token) {
        throw new Error('No valid token found');
      }
      return token;
    } catch (error) {
      console.error('Auth token error:', error);
      throw new Error('Authentication required');
    }
  }

  async searchBusinesses(businessName, address) {
    const token = await this.getAuthToken();
    
    const response = await fetch(`${API_BASE_URL}/oauth/business-lookup`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        business_name: businessName,
        address: address
      })
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Please sign in again to search for businesses');
      }
      if (response.status === 429) {
        throw new Error('Too many requests. Please wait a moment and try again');
      }
      throw new Error(`Search failed. Please try again later (${response.status})`);
    }

    return await response.json();
  }

  async populateBusinessData(businessName, address = '') {
    const token = await this.getAuthToken();
    
    const response = await fetch(`${API_BASE_URL}/oauth/business-lookup/populate`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        business_name: businessName,
        address: address
      })
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Please sign in again to get business details');
      }
      if (response.status === 404) {
        throw new Error('Business details not found. Please try manual entry');
      }
      throw new Error(`Failed to get business details. Please try again (${response.status})`);
    }

    return await response.json();
  }
}

export default new BusinessLookupService();